import { DesignerInfoContextMenuItems } from '@/components/designer-info-context-menu-items';
import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuTrigger,
} from '@/components/ui/context-menu';
import {
  DESIGNER_CONTACT_INFO_ITEMS,
  DESIGNER_PROFILE_INFO_ITEM,
} from '@/config/designer-info';
import type { DesignerInfoItem } from '@/config/designer-info';
import { copy_text_to_clipboard } from '@/lib/copy-text-to-clipboard';
import { cn } from '@/lib/utils';

const DESIGNER_INFO_BANNER_CLASS_NAME =
  'pointer-events-auto sticky top-0 z-50 flex w-full select-text';
const DESIGNER_INFO_BANNER_CONTENT_CLASS_NAME =
  'flex h-12 w-full items-center justify-between bg-[#efefef] px-7 text-[#313131] shadow-[0_8px_28px_rgba(0,0,0,0.12)] md:h-[54px] md:border-y md:border-[#dedede] md:bg-white md:px-[44px] md:shadow-none';
const DESIGNER_CONTACT_GROUP_CLASS_NAME =
  'flex min-w-0 shrink-0 items-center gap-4 md:gap-[34px]';
const DESIGNER_INFO_ITEM_CLASS_NAME =
  'min-w-0 touch-manipulation select-text border-0 bg-transparent p-0 text-[#111111] tracking-normal hover:cursor-copy focus:outline-none focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-[#8e8e8e]';
const DESIGNER_PROFILE_ITEM_CLASS_NAME =
  'text-left text-[16px] font-semibold leading-none md:text-[18px]';
const DESIGNER_CONTACT_ITEM_CLASS_NAME =
  'text-right text-[14px] font-medium leading-none md:text-[18px]';
const DESIGNER_EMAIL_ITEM_CLASS_NAME = 'hidden md:block';

export function DesignerInfoBanner() {
  return (
    <ContextMenu>
      <ContextMenuTrigger asChild>
        <aside
          aria-label="设计师信息"
          className={DESIGNER_INFO_BANNER_CLASS_NAME}
        >
          <div className={DESIGNER_INFO_BANNER_CONTENT_CLASS_NAME}>
            <DesignerInfoBannerItem
              designer_info_item={DESIGNER_PROFILE_INFO_ITEM}
            />
            <div className={DESIGNER_CONTACT_GROUP_CLASS_NAME}>
              {DESIGNER_CONTACT_INFO_ITEMS.map(designer_info_item => (
                <DesignerInfoBannerItem
                  key={designer_info_item.type}
                  designer_info_item={designer_info_item}
                />
              ))}
            </div>
          </div>
        </aside>
      </ContextMenuTrigger>
      <ContextMenuContent>
        <DesignerInfoContextMenuItems />
      </ContextMenuContent>
    </ContextMenu>
  );
}

function DesignerInfoBannerItem({
  designer_info_item,
}: {
  designer_info_item: DesignerInfoItem;
}) {
  return (
    <button
      aria-label={`复制${designer_info_item.label}`}
      className={get_designer_info_item_class_name(designer_info_item)}
      onClick={() => copy_text_to_clipboard(designer_info_item.label)}
      type="button"
    >
      {designer_info_item.label}
    </button>
  );
}

function get_designer_info_item_class_name(
  designer_info_item: DesignerInfoItem,
) {
  return cn(
    DESIGNER_INFO_ITEM_CLASS_NAME,
    designer_info_item.type === 'profile' ?
      DESIGNER_PROFILE_ITEM_CLASS_NAME
    : DESIGNER_CONTACT_ITEM_CLASS_NAME,
    designer_info_item.type === 'email' && DESIGNER_EMAIL_ITEM_CLASS_NAME,
  );
}
